import merge from 'lodash/merge'
import setWith from 'lodash/setWith'

const validator = (schema) => async (values) => {
  try {
    await schema.validate(values, { abortEarly: false })
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      //console.info('validation errors:', err)
      //console.info('validation errors:', err.inner || err)
    }
    if (!err.inner || !err.inner.length) {
      throw setWith({}, err.path, err.message)
    }

    throw err.inner.reduce(
      (errors, err) => merge(errors, setWith({}, err.path, err.message)),
      {},
    )
  }
}

export default validator
